module.exports = __webpack_public_path__ + "static/media/closeIcon.cfbe70f0.svg";